import { render, staticRenderFns } from "./SpecialismsPage.vue?vue&type=template&id=e266468e&"
import script from "./SpecialismsPage.vue?vue&type=script&lang=js&"
export * from "./SpecialismsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports